<div class="main medication-detail">
    <div class="card">
        <h3 class="title">Medication Detail</h3>
        <div class="grid-container">
            <div class="grid-item" *ngIf="medicationDetail?.farmName">
                <label>Farm:</label>
                <span>{{ medicationDetail?.farmName }}</span>
            </div>

            <div class="grid-item">
                <label>Brand:</label>
                <span>{{ medicationDetail?.name }}</span>
            </div>
             <div class="grid-item">
                <label> Arabic Brand: </label>
                <span>{{ medicationDetail?.arabicBrandName }}</span>
            </div>

            <div class="grid-item">
                <label>Minimum Stock Alert:</label>
                <span>{{ medicationDetail?.minimumStockAlert }}</span>
            </div>

            <div class="grid-item">
                <label>Medication Unit:</label>
                <span>{{
                    getMedicationUnitLabel(medicationDetail?.medicationUnit)
                }}</span>
            </div>

            <div class="grid-item">
                <label>Supplier:</label>
                <span>{{ medicationDetail?.supplierName }}</span>
            </div>

            <div class="grid-item">
                <label>Expire Date:</label>
                <span>{{
                    medicationDetail?.expiryDate | date: 'dd/MM/yyyy'
                }}</span>
            </div>

            <div class="grid-item">
                <label>Type:</label>
                <span>{{ medicationDetail?.chickTypeName }}</span>
            </div>

            <div class="grid-item">
                <label>Application Type:</label>
                <span>{{ medicationDetail?.applicationType }}</span>
            </div>

            <div class="grid-item">
                <label>Batch Number:</label>
                <span>{{ medicationDetail?.batchNumber }}</span>
            </div>

            <div class="grid-item">
                <label>Quantity:</label>
                <span>{{ medicationDetail?.qty }}</span>
            </div>

            <div class="grid-item">
                <label>Chick From:</label>
                <span>{{ medicationDetail?.chickAgeFrom }}</span>
            </div>

            <div class="grid-item">
                <label>Chick Age To:</label>
                <span>{{ medicationDetail?.chickAgeTo }}</span>
            </div>

            <div class="grid-item">
                <label>Classification:</label>
                <span>{{ medicationDetail?.classificationName }}</span>
            </div>

            <div class="grid-item grid-item--description">
                <label>Notes:</label>
                <span class="description-text">{{
                    medicationDetail?.description
                }}</span>
            </div>
        </div>
    </div>
</div>
